import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { selectObjects, getMap } from 'ducks/editor/objects'
import getObject from 'ducks/editor/objects/helpers/getObject'
import centerScreenOnCanvas from 'utils/objects/centerScreenOnCanvas'

interface UseScreenNavigationReturn {
  handleScreenClick: (screenId: string, componentId?: string) => void
  handleKeyDown: (e: React.KeyboardEvent, screenId: string) => void
}

export const useScreenNavigation = (
  appId: string
): UseScreenNavigationReturn => {
  const dispatch = useDispatch()
  const history = useHistory()
  const objectList = useSelector(selectObjects)
  const pathMap = useSelector(getMap)

  const handleScreenClick = useCallback(
    (screenId: string, componentId?: string) => {
      try {
        const screenObject = getObject(objectList, pathMap, screenId)
        history.push(`/apps/${appId}/screens`)
        dispatch(centerScreenOnCanvas(screenObject, componentId))
      } catch (err) {
        console.error('Error centering screen:', err)
      }
    },
    [dispatch, objectList, pathMap, appId, history]
  )

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent, screenId: string) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        handleScreenClick(screenId)
      }
    },
    [handleScreenClick]
  )

  return {
    handleScreenClick,
    handleKeyDown,
  }
}
